import React from 'react';

/**
 * Global error boundary — a render crash anywhere in the tree used to
 * blank the whole app (black screen). Now we show a friendly recover card.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background px-6" data-testid="error-boundary-fallback">
          <div className="max-w-md text-center">
            <p className="text-sm uppercase tracking-wider text-muted-foreground">Something went wrong</p>
            <h1 className="text-2xl font-bold mt-2">This page hit a snag</h1>
            <p className="text-muted-foreground mt-2 text-sm">
              Your data is safe. Reload the page to pick up where you left off — if it keeps happening, let us know.
            </p>
            <div className="flex gap-3 justify-center mt-5">
              <button
                onClick={() => window.location.reload()}
                className="px-5 py-2 rounded-full text-sm font-semibold text-white bg-gradient-to-r from-fuchsia-500 to-indigo-500 hover:opacity-90"
                data-testid="error-boundary-reload"
              >
                Reload page
              </button>
              <button
                onClick={() => { window.location.href = '/'; }}
                className="px-5 py-2 rounded-full text-sm font-semibold border border-border hover:bg-accent/50"
                data-testid="error-boundary-home"
              >
                Go home
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
